import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const DEFAULT_IPFS_LOCAL = {
	enable: false,
	url: 'http://localhost:5001',
	ipfs_link: '',
	error: '',
	on_air: false
}
interface ILocalGateway {
	enable: boolean
	url: string
	error: string
	on_air: boolean
	ipfs_link: string
}
export interface IPublicGateway {
	type: 'filebase', 
	url?: string
	secret: string
}

interface IPublicGateways {
	enable: boolean
	gateways: IPublicGateway[]
}

interface IConfigStore {
	domain: string
	baseUrl: string
	isCustomBaseURL: boolean
	testMode: boolean
	assetsUrl: string
	gear: boolean
	defaultConnect: {
		domain: string
		backendLink: string
		default_ipfs_link: string
	}
	version: {
		version: number
		reload: boolean
	}
	localGateway: ILocalGateway
	localGatewayPort: string
	publicGateways: IPublicGateways
	setPublicGateways: (state: IPublicGateways) => void
	setLocalGateway: (state: ILocalGateway) => void
	setLocalGatewayPort: (state: string) => void
	setAssetsUrl: (state: string) => void
	setDomain: (state: string) => void
	setBaseUrl: (state: string) => void
	setTestMode: (state: boolean) => void
	setGear: (state: boolean) => void
	setVersion: (state: IConfigStore['version']) => void
	setIsCustomBaseUrl: (state: boolean) => void
}

export const ConfigStore = create<IConfigStore>()(
	persist(
		(set) => ({
			domain: '',
			baseUrl: '',
			defaultConnect: {
				domain: '',
				backendLink: '',
				default_ipfs_link: '',
			},
			version: {
				version: 0,
				reload: false,
			},
			testMode: false,
			assetsUrl: '',
			gear: false,
			isCustomBaseURL: false,
			localGateway: DEFAULT_IPFS_LOCAL,
			localGatewayPort: '',
			publicGateways: {enable: false, gateways: []} as IPublicGateways,
			setPublicGateways(state) {
				set({ publicGateways: state })
			},
			setLocalGateway: (state: ILocalGateway) => set({ localGateway: state }),
			setLocalGatewayPort:  state => set({ localGatewayPort: state }),
			setDefaultConnect: state => set({ defaultConnect: state }),
			setDomain: state => set({ domain: state }),
			setGear: state => set({ gear: state }),
			setBaseUrl: state => set({ baseUrl: state }),
			setTestMode: state => set({ testMode: state }),
			setAssetsUrl: state => set({ assetsUrl: state }),
			setVersion: (state: IConfigStore['version']) => set({ version: state }),
			setIsCustomBaseUrl: (state: boolean) => set({ isCustomBaseURL: state })
		}),
		{
			name: 'config',
			partialize: state => ({...state })
		}
	)
)